//@flow strict
import React from 'react';
import Link from '../../../components/Link';

const config = {
  title: 'Healthy office snacks to fuel your hungry team!',
  subtitle: 'We offer a range of office snacking options for teams of all sizes.',
  cta: 'Get Office Snacks',
};

export default function OfficeHero2() {
  return (
    <div className="office-hero-2">
      <div className="hero-image-container">
        <div className="text-container">
          <h1 className="header-text">
            {config.title}
          </h1>
          <div className="text-2 description">
            {config.subtitle}
          </div>
          <Link to="/office#office-form">
            <button className="cta">
              {config.cta}
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}
